import React from 'react';
import img from "./images/accept.png"
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
const Finished = () => {
     const { t } = useTranslation();
     const {id} =useParams()
     console.log(id);
     
    return (
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column", marginTop:"150px"}}>
            <img src={img} alt=""width={100} height={100}/>
            <div style={{marginTop:"50px",display:"flex",alignItems:"center",flexDirection:"column"}}>
                <Typography variant="h3" sx={{fontFamily:"oswald,cairo",fontWeight:"bolder"}}>
                  {t('finished.mass1')}
            </Typography>
             <Typography variant="h4" sx={{fontFamily:"oswald,cairo",mt:"10px",color:"gray"}}>
               {t('finished.mass2')} 
            </Typography>
              <Typography variant="h4" style={{color:"#4bae4f",marginTop:"10px",fontWeight:"bolder"}}>{id} </Typography>
            </div>
        </div>
    );
}

export default Finished;
